import React, { useEffect, useMemo } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Container } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { checkIsDukePNGPortalSubdomain, getSubdomainFromUrl } from "../utils/urlUtils";
import NavBar from "./general-nav";

const ChatBotBody = ({ chatbotAppId, title, heading, newBot=false }) => {
    const [searchParams, ] = useSearchParams();

    // 
    const botUrl = newBot ?  
        `https://mylinkconnect-res.mbdt01.com/landing/display.html?route=bXlsaW5rY29ubmVjdC1yb3V0aW5nLm1iZHQwMS5jb20*&bot_key=${chatbotAppId}&${searchParams.toString()}` : 
        `https://chatexperience.linkmobility.com/lp/land.html?nfo=chatexperience/${chatbotAppId}&${searchParams.toString()}`;

    const companyCode = checkIsDukePNGPortalSubdomain(getSubdomainFromUrl(window.location.href));

    const bannerImage = useMemo(() => {
        const behaviour = searchParams.get("behaviour");
        
        return companyCode === "PNG" ? "logo-piedmont.png" : (behaviour === "heu_sc" ? "duke-progress.svg" : "white-duke.jpg");
    }, [searchParams, companyCode]);

    useEffect(() => {
        document.title = title;
    }, [title]);

    return(
        <>
            <NavBar title={heading} imageName={bannerImage} />
            <HelmetProvider key={chatbotAppId}>
                <Helmet script={
                    [{type: "text/javascript", innerHTML: `xenioowebchat.EmbedChatLanding({ container: "chatexperience",  landingUrl: "${botUrl}" })`}]
                }  />

                <Container>
                    <div id="chatexperience" style={{width: "100%", height: 600}}></div>
                </Container>
            </HelmetProvider>
        </>
        
    );
}

export default ChatBotBody;